import { render, staticRenderFns } from "./TeachersInCantonForSchoolYear.vue?vue&type=template&id=3870cdd8&scoped=true"
import script from "./TeachersInCantonForSchoolYear.vue?vue&type=script&lang=js"
export * from "./TeachersInCantonForSchoolYear.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3870cdd8",
  null
  
)

export default component.exports